import script from "./wrtTmpPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./wrtTmpPage.vue?vue&type=script&setup=true&lang=ts"

import "./wrtTmpPage.vue?vue&type=style&index=0&id=012d343a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-012d343a"]])

export default __exports__